import React from 'react';
import './App.css';
import * as microsoftTeams from '@microsoft/teams-js';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import MarcacionDocente from './components/marcacion-docente/marcacion-docente';

const App = () => {
  microsoftTeams.initialize();

  return (
    <Router>
      <Route exact path='/tab' component={MarcacionDocente} />
    </Router>
  );
};

export default App;
